import { useRecoilState } from "recoil";
import { headerVisibleState } from "../store/HeaderVisibleState";

function ToggleHeader() {
  const [headerVisible, setHeaderVisible] = useRecoilState(headerVisibleState);

  function onClickHandler() {
    setHeaderVisible(!headerVisible);
  }

  return (
    <div className="toggleHeader">
      <div className={`toggle-button mini ${headerVisible? 'top-arrow': 'bottom-arrow'}`} onClick={onClickHandler}/>
    </div>
  );
}

export default ToggleHeader;